import * as React from "react"
import request from "@/server/request"
import config from "@/server/config"

import UploadImg from "@/pages/components/uploadImg"
import Dialog from "@/pages/components/dialog"
import { PickerBox } from "@/pages/components/picker"
import Umeditor from "@/pages/components/umeditor"
import ActionSheet from "@/pages/components/common/ui/actionsheet"
import alert from "@/pages/components/common/alert"
import { uploadVideoMultiChunks } from "@/server/upload"

import "@/pages/containers/auth/scss/form.scss"
import "../scss/index.scss"

const Toast = require("react-toast-mobile")

export default class CommodityRelease extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    const location = this.props.location
    this.state = {
      companyId:
        location.state && location.state.companyId
          ? location.state.companyId
          : "", // 企业id
      operation:
        location.state && location.state.operation
          ? location.state.operation
          : "", // 操作行为 edit 为编辑
      goods_id:
        location.state && location.state.goods_id ? location.state.goods_id : 0, // 商品id 编辑删除时候用
      goods_status: location.state ? location.state.goods_status : "", // 商品上架状态
      goods_cate_fir: "", // 店铺一级分类id
      goods_cate_sec: "", // 2
      goodsCateName: "",
      goods_name: "", // 商品名称
      grade: "", // 牌号
      manufacturer: "", // 生产商

      showAttribute: false, // 物性特征
      phyical: [], // 物性数据 sort name numerical unit remark
      attributeSort: "", // 排序
      attributeName: "", // 物性名称
      attributeNumerical: "", // 物性值
      attributeUnit: "", // 物性单位
      attributeRemark: "", // 备注
      attributeAperation: "", // 物性操作
      editIndex: -1, // 操作索引

      showUnit: false, // 计量单位
      radioUnitIndex: 0, // 单位单选按钮
      unit_type: -1, // 计量单位
      unit_customize: "", // 自定义单位名称，选3必须传值

      point_num: "", // 计量单位小数
      price_type: "1", // 价格类型
      showHierarchicalPrice: false, // 梯度弹窗
      price: [
        {
          begin_num: "", // 梯度价格数组
          end_num: "",
          origin_price: "",
          discount_price: "",
          price_level: "",
        },
      ],
      priceText: "", //梯度价格选择结果
      price_data: [
        {
          begin_num: "",
          end_num: "",
          origin_price: "",
          discount_price: "",
          price_level: "",
        },
      ], //区间价格
      show_origin_price: "", // 原价
      show_discount_price: "", //	优惠价
      reference_price: "", // 参考价
      warehouse: "", // 仓库地址
      stock: "", // 库存
      goods_img: [], // 图片集合数组，至少传1张
      platform_cate_fir: "", // 平台分类1级
      platform_cate_sec: "", // 2
      platform_cate_thr: "", // 3
      plateformName: "", // 平台分类中文

      goods_desc: "", // 商品描述
      showEditor: false, // 显示富文本
      goodsInfoText: "", // 商品详情字段
      type_id: [], // 特色商品

      ce: "",
      // 商品分类
      commodityClassifyData: [],
      // 平台分类
      plateformClassifyData: [],
      checkboxList: [], // 多选列表
      is_cmall_goods: "0", // 是否是cmall的商品

      videoPoster: "",
      video: "",
      videoCutPoster: "", // 裁切视频第一帧作为备用视频海报
    }
  }

  public componentDidMount() {
    this.getCommodityClassify()
    this.getPlateformClassify()
    this.getCommodityLabel()

    if (this.state.operation === "edit") {
      this.initData()
    }
  }

  public render() {
    return (
      <div className="gray-bg page-commodityRelease">
        <ActionSheet project="store" />
        {this.state.showEditor ? (
          <div className="fix-editor">
            <Umeditor
              change={(v: any) => this.changeEditor(v)}
              defaultValue={this.state.goods_desc}
            ></Umeditor>
            <div className="editor-bottom">
              <p className="prompt">
                建议至少插入3张以上宽度不小于700像素的细节图进行描述...
              </p>
              <button className="btn" onClick={() => this.onConfrimEditor()}>
                保存修改
              </button>
              <button
                className="btn gray-btn"
                onClick={() => this.changeState("showEditor", false)}
              >
                取消
              </button>
            </div>
          </div>
        ) : (
          ""
        )}

        <Dialog visiblity={this.state.showUnit}>
          <div className="fill-box">
            <span
              className="fill-box-close"
              onClick={() => this.changeState("showUnit", false)}
            ></span>
            <p className="fill-title">计量单位</p>
            <div className="radio-box">
              <div className="radio-item">
                <i
                  className={`radio-icon ${
                    this.state.radioUnitIndex === 1 ? "active" : ""
                  }`}
                  onClick={() => this.changeState("radioUnitIndex", 1)}
                />
                <span className="text">吨</span>
              </div>
              <div className="radio-item">
                <i
                  className={`radio-icon ${
                    this.state.radioUnitIndex === 2 ? "active" : ""
                  }`}
                  onClick={() => this.changeState("radioUnitIndex", 2)}
                />
                <span className="text">件</span>
              </div>
              <div className="radio-item">
                <i
                  className={`radio-icon ${
                    this.state.radioUnitIndex === 3 ? "active" : ""
                  }`}
                  onClick={() => this.changeState("radioUnitIndex", 3)}
                />
                <input
                  disabled={this.state.radioUnitIndex !== 3}
                  type="text"
                  className="radio-input"
                  placeholder="自定义单位"
                  value={this.state.unit_customize}
                  onChange={(e: any) =>
                    this.changeState("unit_customize", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="fill-btn">
              <button
                className="btn"
                onClick={() => this.changeState("showUnit", false)}
              >
                取消
              </button>
              <button
                className="btn font-blod"
                onClick={() => this.onConfirmUnit()}
              >
                确定
              </button>
            </div>
          </div>
        </Dialog>

        <Dialog visiblity={this.state.showHierarchicalPrice}>
          <div className="fill-box">
            <span
              className="fill-box-close"
              onClick={() => this.changeState("showHierarchicalPrice", false)}
            ></span>
            <p className="fill-title">梯度价格</p>
            <div className="price-box">
              {this.state.price_data.map((v: any, k: number) => {
                return (
                  <div className="price-item" key={k}>
                    <div className="left">
                      {k === 0 ? <p className="label">数量:</p> : ""}
                      {k === 0 ? <p className="label">价格:</p> : ""}
                      {k !== 0 ? (
                        <i
                          className="remove-btn"
                          onClick={() => this.removePrice(k)}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="right">
                      <p className="price-input-box">
                        <input
                          type="number"
                          className="price-input"
                          placeholder="数量"
                          value={this.state.price_data[k].begin_num}
                          onChange={(e: any) =>
                            this.changeGradientInputVal(
                              "begin_num",
                              e.target.value,
                              k
                            )
                          }
                        />
                        <span className="line"></span>
                        <input
                          disabled={k + 1 === this.state.price_data.length}
                          type="number"
                          className="price-input"
                          placeholder="数量"
                          value={this.state.price_data[k].end_num}
                          onChange={(e: any) =>
                            this.changeGradientInputVal(
                              "end_num",
                              e.target.value,
                              k
                            )
                          }
                        />
                      </p>

                      <p className="price-input-box">
                        <input
                          type="number"
                          className="price-input"
                          placeholder="原价"
                          value={this.state.price_data[k].origin_price}
                          onChange={(e: any) =>
                            this.changeGradientInputVal(
                              "origin_price",
                              e.target.value,
                              k
                            )
                          }
                        />
                        <span className="line"></span>
                        <input
                          type="number"
                          className="price-input"
                          placeholder="促销价"
                          value={this.state.price_data[k].discount_price}
                          onChange={(e: any) =>
                            this.changeGradientInputVal(
                              "discount_price",
                              e.target.value,
                              k
                            )
                          }
                        />
                      </p>
                    </div>
                  </div>
                )
              })}
            </div>
            <p className="price-bottom">
              <span className="add-btn" onClick={() => this.addGradient()}>
                +添加梯度
              </span>
            </p>
            <div className="fill-btn">
              <button
                className="btn"
                onClick={() => this.changeState("showHierarchicalPrice", false)}
              >
                取消
              </button>
              <button
                className="btn font-blod"
                onClick={() => this.onConfrimGradient()}
              >
                确定
              </button>
            </div>
          </div>
        </Dialog>

        <Dialog visiblity={this.state.showAttribute}>
          <div className="fill-box">
            <span
              className="fill-box-close"
              onClick={() => this.changeState("showAttribute", false)}
            ></span>
            <p className="fill-title">新增物性特征</p>
            <div className="attribute-box">
              <div className="row-box">
                <input
                  type="number"
                  className="attribute-input input1"
                  placeholder="排序"
                  value={this.state.attributeSort}
                  onChange={(e: any) =>
                    this.changeState(
                      "attributeSort",
                      e.target.value !== "" ? parseInt(e.target.value) : ""
                    )
                  }
                />
                <input
                  type="text"
                  className="attribute-input input2"
                  placeholder="物性名称"
                  value={this.state.attributeName}
                  onChange={(e: any) =>
                    this.changeState("attributeName", e.target.value)
                  }
                />
              </div>
              <div className="row-box">
                <input
                  type="text"
                  className="attribute-input input3"
                  placeholder="物性值"
                  value={this.state.attributeNumerical}
                  onChange={(e: any) =>
                    this.changeState("attributeNumerical", e.target.value)
                  }
                />
                <input
                  type="text"
                  className="attribute-input input3"
                  placeholder="物性单位"
                  value={this.state.attributeUnit}
                  onChange={(e: any) =>
                    this.changeState("attributeUnit", e.target.value)
                  }
                />
              </div>
              <div className="row-box">
                <input
                  type="text"
                  className="attribute-input"
                  placeholder="备注"
                  value={this.state.attributeRemark}
                  onChange={(e: any) =>
                    this.changeState("attributeRemark", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="fill-btn">
              {this.state.attributeAperation === "edit" ? (
                <button
                  className="btn red"
                  onClick={() => this.removeAttribute()}
                >
                  删除
                </button>
              ) : (
                ""
              )}
              {this.state.attributeAperation !== "edit" ? (
                <button
                  className="btn"
                  onClick={() => this.changeState("showAttribute", false)}
                >
                  取消
                </button>
              ) : (
                ""
              )}
              <button
                className="btn font-blod"
                onClick={() => this.changeAttribute()}
              >
                确定
              </button>
            </div>
          </div>
        </Dialog>

        <div className="default-form">
          <div className="form-input-warrper">
            <label className="label">
              <span className="red">*</span>商品分类
            </label>
            <button
              className="input-select text-right"
              data-value={this.state.goodsCateName || ""}
              onClick={() => this.showCommodityClassify()}
            >
              {this.state.goodsCateName || "请输入商品分类"}
            </button>
          </div>
        </div>
        <div className="form-list">
          <h3 className="list-title">商品基本信息</h3>
          <div className="default-form">
            <div className="form-input-warrper">
              <label className="label">
                <span className="red">*</span>商品名称
              </label>
              <input
                type="text"
                placeholder="请填写商品名称"
                className="text-right"
                value={this.state.goods_name}
                onChange={(e: any) =>
                  this.changeState("goods_name", e.target.value)
                }
                readOnly={this.state.is_cmall_goods === "1"}
              />
            </div>
          </div>
          <div className="list-tips">
            勿使用联系人、联系方式、疑问词句,特殊字符及堆砌关键词
          </div>
          <div className="default-form">
            <div className="form-input-warrper">
              <label className="label">牌号</label>
              <input
                type="text"
                placeholder="请填写牌号"
                className="text-right"
                value={this.state.grade}
                onChange={(e: any) => this.changeState("grade", e.target.value)}
                readOnly={this.state.is_cmall_goods === "1"}
              />
            </div>
            <div className="form-input-warrper">
              <label className="label">生产商</label>
              <input
                type="text"
                placeholder="请填写生产商"
                className="text-right"
                value={this.state.manufacturer}
                onChange={(e: any) =>
                  this.changeState("manufacturer", e.target.value)
                }
                readOnly={this.state.is_cmall_goods === "1"}
              />
            </div>
          </div>

          <div className="form-input-add mt-20">
            <div className="add-item">
              <span className="left">物性特征</span>
              <span
                className="right blue"
                onClick={() => this.showAttributeBox()}
              >
                <i className="add-icon" />
                新增
              </span>
            </div>
            {this.state.phyical.map((v: any, k: number) => {
              return (
                <div
                  className="add-item"
                  key={k}
                  onClick={() => this.editAttribute(v, k)}
                >
                  <span
                    className="left line-clamp-1"
                    dangerouslySetInnerHTML={{
                      __html: v.name + v.numerical + v.unit + v.remark,
                    }}
                  ></span>
                  <span className="right">
                    <i className="right-icon" />
                  </span>
                </div>
              )
            })}
          </div>
        </div>

        <div className="form-list">
          <h3 className="list-title">商品交易信息</h3>
          <div className="default-form">
            <div className="form-input-warrper">
              <label className="label">
                <span className="red">*</span>计量单位
              </label>
              <button
                className="input-select text-right"
                data-value={
                  this.state.unit_type === 3
                    ? this.state.unit_customize
                    : this.state.unit_type === 1
                    ? "吨"
                    : this.state.unit_type === 2
                    ? "件"
                    : ""
                }
                onClick={() => this.showUnitContainer()}
              >
                {(this.state.unit_type === 3
                  ? this.state.unit_customize
                  : this.state.unit_type === 1
                  ? "吨"
                  : this.state.unit_type === 2
                  ? "件"
                  : "") || "请输入计量单位"}
              </button>
            </div>
            <div className="form-input-warrper">
              <label className="label">
                <span className="red">*</span>采购量小数位数
              </label>
              <input
                type="number"
                placeholder="请填写采购量小数位"
                className="text-right"
                value={this.state.point_num}
                onChange={(e: any) =>
                  this.changeState(
                    "point_num",
                    e.target.value ? parseInt(e.target.value) : ""
                  )
                }
                readOnly={this.state.is_cmall_goods === "1"}
              />
            </div>
            <div className="form-input-warrper">
              <label className="label">
                <span className="red">*</span>商品单价
              </label>
              <button
                className="input-select text-right"
                data-value={
                  (this.state.price_type === "1"
                    ? "梯度价格"
                    : this.state.price_type === "2"
                    ? "单一价格"
                    : this.state.price_type === "4"
                    ? "参考价"
                    : "") || ""
                }
                onClick={() => this.showCommodityUnit()}
              >
                {(this.state.price_type === "1"
                  ? "梯度价格"
                  : this.state.price_type === "2"
                  ? "单一价格"
                  : this.state.price_type === "4"
                  ? "参考价"
                  : "") || "请输入商品单价"}
              </button>
            </div>
            {this.state.price_type === "1" ? (
              <div className="form-input-warrper">
                <label className="label">
                  <span className="red">*</span>商品规格
                </label>
                <button
                  className="input-select text-right"
                  data-value={this.state.priceText || ""}
                  onClick={() => this.showGradient()}
                >
                  {this.state.priceText || "请输入商品规格"}
                </button>
              </div>
            ) : (
              ""
            )}

            {this.state.price_type === "2" ? (
              <div className="form-input-warrper">
                <label className="label">
                  <span className="red">*</span>原价
                </label>
                <input
                  type="text"
                  placeholder="请填写原价"
                  className="text-right"
                  value={this.state.show_origin_price}
                  onChange={(e: any) =>
                    this.changeState("show_origin_price", e.target.value)
                  }
                  readOnly={this.state.is_cmall_goods === "1"}
                />
              </div>
            ) : (
              ""
            )}
            {this.state.price_type === "2" ? (
              <div className="form-input-warrper">
                <label className="label">
                  <span className="red">*</span>促销价
                </label>
                <input
                  type="text"
                  placeholder="请填写促销价"
                  className="text-right"
                  value={this.state.show_discount_price}
                  onChange={(e: any) =>
                    this.changeState("show_discount_price", e.target.value)
                  }
                  readOnly={this.state.is_cmall_goods === "1"}
                />
              </div>
            ) : (
              ""
            )}
            {this.state.price_type === "4" ? (
              <div className="form-input-warrper">
                <label className="label">参考价</label>
                <input
                  type="text"
                  placeholder="请填写参考价"
                  className="text-right"
                  value={this.state.reference_price}
                  onChange={(e: any) =>
                    this.changeState("reference_price", e.target.value)
                  }
                  readOnly={this.state.is_cmall_goods === "1"}
                />
              </div>
            ) : null}
          </div>
          <div className="list-tips">
            商品价格分为梯度价格、单一价格和参考价3种。
          </div>
          <div className="default-form">
            <div className="form-input-warrper">
              <label className="label">仓库</label>
              <input
                type="text"
                placeholder="请填写仓库"
                className="text-right"
                value={this.state.warehouse}
                onChange={(e: any) =>
                  this.changeState("warehouse", e.target.value)
                }
                readOnly={this.state.is_cmall_goods === "1"}
              />
            </div>
            <div className="form-input-warrper">
              <label className="label">
                <span className="red">*</span>库存
              </label>
              <input
                type="text"
                placeholder="请填写库存"
                className="text-right"
                value={this.state.stock}
                onChange={(e: any) => this.changeState("stock", e.target.value)}
                readOnly={this.state.is_cmall_goods === "1"}
              />
            </div>
          </div>
        </div>

        <div className="form-list">
          <h3 className="list-title">图片和详细说明</h3>
          <div className="form-upload-group">
            <p className="upload-title">
              <span className="red">*</span>商品图片
            </p>
            <div className="upload-list">
              {this.state.goods_img.map((v: any, k: number) => {
                return (
                  <div className="item" key={k}>
                    <UploadImg
                      project="store"
                      sucess={(data: any) => this.changeImageUrl(data, k)}
                      remove={() => this.removeAction(k)}
                      id={v}
                      readOnly={this.state.is_cmall_goods === "1"}
                      size="1024"
                    />
                  </div>
                )
              })}
              {this.state.goods_img.length < 5 &&
              this.state.is_cmall_goods !== "1" ? (
                <UploadImg
                  sucess={(data: any) => this.imgSuccess(data)}
                  isBtn={true}
                  size="10240"
                />
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="list-tips upload-tips">
            您可以上传5张图片, 每张大小不可以超过10M, 第1张将作为产品主图。
            建议上传至少3张以上, 不小于400*400像素的 真实图片,
            支持jpg,jpeg,gif,bmp格式。
          </div>
          <div className="form-upload-group">
            <p className="upload-title">商品视频</p>
            <div className="upload-list">
              <div className="upload-video-item">
                {this.state.videoPoster && (
                  <div className="upload-result-wrapper">
                    <span onClick={() => this.deleteVideoPoster()}></span>
                    <img src={config.IMGAPI + this.state.videoPoster} />
                  </div>
                )}
                <UploadImg
                  project="store"
                  text="视频封面"
                  sucess={(data: any) => this.uploadVideoPoster(data)}
                  isBtn={true}
                  format="jpg|jpeg|gif|bmp|png"
                  size="1024"
                />
              </div>
              <div className="upload-video-item">
                {this.state.video && (
                  <div className="upload-result-wrapper">
                    <span onClick={() => this.deleteVideo()}></span>
                    <video src={config.MALLAPI + this.state.video} controls />
                  </div>
                )}
                <div className="upload-img upload-video-btn">
                  <input
                    type="file"
                    accept="video/mp4"
                    onChange={(e) => this.uploadVideo(e)}
                  />
                  <p>上传视频</p>
                </div>
              </div>
            </div>
          </div>
          <div className="list-tips upload-tips">
            封面图只能上传一张，支持jpg、jpeg、gif、bmp格式，且最大不超过1M，
            <br />
            视频支持MP4格式，建议上传视频不超过100M
          </div>
          <div className="default-form">
            <div className="form-input-warrper">
              <label className="label">
                <span className="red">*</span>商品详情
              </label>
              <button
                className="input-select text-right"
                data-value={this.state.goods_desc || ""}
                onClick={() => this.showEditorContainer()}
              >
                {(this.state.goods_desc ? "已设置" : "") || "请输入商品详情"}
              </button>
            </div>
          </div>
        </div>
        <div className="form-list">
          <h3 className="list-title">其他信息</h3>
          <div className="default-form">
            <div className="form-input-warrper">
              <label className="label">
                <span className="red">*</span>平台分类
              </label>
              <button
                className="input-select text-right"
                data-value={this.state.plateformName || ""}
                onClick={() => this.showPlateformClassify()}
              >
                {this.state.plateformName || "请输入平台分类"}
              </button>
            </div>
            <div className="form-checkbox">
              <h3 className="checkbox-title">特色商品</h3>
              <div className="checkbox-list">
                {this.state.checkboxList.map((v: any, k: any) => {
                  return (
                    <span
                      className={`item ${
                        this.state.type_id.indexOf(v.id) !== -1 ? "active" : ""
                      }`}
                      key={k}
                      onClick={() => this.changeCheckbox(v)}
                    >
                      <i className="checkbox-icon" />
                      {v.name}
                    </span>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
        {this.state.is_cmall_goods === "0" ? (
          <div className="mt-20 commodit-bottom">
            {this.state.operation === "edit" ? (
              <button
                className="commodit-btn waring-btn float-l ml-10"
                onClick={() => this.removeCommodity()}
              >
                删除
              </button>
            ) : (
              ""
            )}
            <button
              className="commodit-btn primary-btn float-r ml-24"
              onClick={() => this.submitForm(1)}
            >
              {this.state.operation === "edit" ? "修改" : "发布"}
            </button>
            {/*{
							this.state.operation !== 'edit' ? <button className="commodit-btn float-r" onClick={() => this.submitForm(2) }>下架</button> : null
						}*/}
            {this.state.operation === "edit" ? (
              <button
                className="commodit-btn float-r"
                onClick={() => this.changeCommodityStatus()}
              >
                {this.state.goods_status === "1" ? "下架" : "上架"}
              </button>
            ) : (
              ""
            )}
          </div>
        ) : null}
        <canvas className="canvas-hide" id="video-canvas"></canvas>
        <video
          className="canvas-hide"
          id="video"
          src={config.MALLAPI + this.state.video}
          controls={false}
        />
      </div>
    )
  }

  private async initData() {
    const r = await request({
      method: "post",
      url: `${config.MALLAPI}api/shop/goods/details`,
      data: {
        companyId: this.state.companyId,
        goods_id: this.state.goods_id,
      },
    })

    if (r.error_code === 0) {
      const data = r.data
      const goods_img = data.img_list.map((v: any) => {
        return v.img_src
      })

      let resultIds: any = []
      data.tag.map((v: any) => {
        if (v.is_checked === 1) {
          resultIds.push(v.id)
        }
      })

      const type_id = resultIds

      this.setPriceText(data.price_section)

      this.setState({
        goods_name: data.goods_name,
        grade: data.grade,
        manufacturer: data.manufacturer,
        unit_type: parseInt(data.unit_type),
        unit_customize: data.unit_customize,
        point_num: data.point_num,
        price_type: data.price_type,
        show_origin_price: data.show_origin_price || "",
        show_discount_price: data.show_discount_price || "",
        warehouse: data.warehouse || "",
        stock: data.stock || "",
        platform_cate_fir: data.platform_cate_fir || "",
        platform_cate_sec: data.platform_cate_sec || "",
        platform_cate_thr: data.platform_cate_thr || "",
        goods_cate_fir: data.goods_cate_fir || "",
        goods_cate_sec: data.goods_cate_sec || "",
        phyical: data.physical,
        goods_img: goods_img,
        price: data.price_section,
        type_id: type_id,
        goods_desc: data.goods_desc,
        goodsCateName: data.goods_cate_fir_name + data.goods_cate_sec_name,
        plateformName:
          data.platform_cate_fir_name +
          data.platform_cate_sec_name +
          data.platform_cate_thr_name,
        reference_price: data.proposed_price > 0 ? data.proposed_price : "",
        is_cmall_goods: data.is_cmall_goods,
        video: data.goods_video,
        videoPoster: data.video_img,
        videoCutPoster: data.video_img_auto,
      })
    }
  }

  // 更新state
  private changeState(k: string, v: any) {
    this.setState({
      [k]: v,
    })
  }
  //  改变多选框
  private changeCheckbox(v: any) {
    if (this.state.is_cmall_goods === "1") {
      return this.cantEdit()
    }

    var index = this.state.type_id.indexOf(v.id)
    if (index === -1) {
      this.setState({ type_id: [...this.state.type_id, v.id] })
    } else {
      this.state.type_id.splice(index, 1)
      this.setState({ type_id: this.state.type_id })
    }
  }

  // 显示商品单价
  private showCommodityUnit() {
    if (this.state.is_cmall_goods === "1") {
      return this.cantEdit()
    }

    ;(PickerBox as any).open({
      data: [
        {
          displayValue(item: any) {
            return item.name
          },
          valueLable: "id",
          list: [
            {
              name: "梯度价格",
              id: 1,
            },
            {
              name: "单一价格",
              id: 2,
            },
            {
              name: "参考价",
              id: 4,
            },
          ],
        },
      ],
      valueLable: "id",

      // 成功回调
      onConfrim: (data: any) => {
        this.setState({
          price_type: data.value,
        })
      },
    })
  }

  //  商品分类
  private async getCommodityClassify() {
    // 获取数据
    const r = await request({
      method: "post",
      url: `${config.MALLAPI}api/wshop/shop/cate`,
      data: {
        companyId: this.state.companyId,
      },
    })

    if (r.error_code === 0) {
      this.setState({
        commodityClassifyData: [
          {
            displayValue(item: any) {
              return item.cate_name
            },
            list: r.data,
          },
          {
            displayValue(item: any) {
              return item.cate_name
            },
            list: [],
          },
        ],
      })
    }
  }

  // 商品分类  联动
  private showCommodityClassify() {
    if (this.state.is_cmall_goods === "1") {
      return this.cantEdit()
    }

    const that = this
    this.setState(
      {
        commodityClassifyData: [
          {
            displayValue(item: any) {
              return item.cate_name
            },
            list: this.state.commodityClassifyData[0].list,
          },
          {
            displayValue(item: any) {
              return item.cate_name
            },
            list: [],
          },
        ],
      },
      () => {
        // 显示弹框
        ;(PickerBox as any).open({
          data: that.state.commodityClassifyData,
          valueLable: "cate_id",
          labelName: "cate_name",
          onChange: (data: any, index: number, arr: any) => {
            const result = arr
            if (data && data.level === 0) {
              this.state.commodityClassifyData[1].list = data.children
              // 重写结果数据
              result[1] = data.children[0]
              ;(PickerBox as any).changeState(result)
            }
          },
          // 成功回调
          onConfrim: (data: any) => {
            this.setState({
              goodsCateName: data.nameArr,
              goods_cate_fir: data.valueArr[0] || 0,
              goods_cate_sec: data.valueArr[1] || 0,
            })
          },
        })
      }
    )
  }

  //  平台分类
  private async getPlateformClassify() {
    // 获取数据
    const r = await request({
      method: "post",
      url: `${config.MALLAPI}api/wshop/goods/platform-cate`,
    })

    if (r.error_code === 0) {
      this.setState({
        plateformClassifyData: [
          {
            displayValue(item: any) {
              return item.cat_name
            },
            list: r.data,
          },
          {
            displayValue(item: any) {
              return item.cat_name
            },
            list: [],
          },
          {
            displayValue(item: any) {
              return item.cat_name
            },
            list: [],
          },
        ],
      })
    }
  }

  // 平台分类  联动
  private showPlateformClassify() {
    if (this.state.is_cmall_goods === "1") {
      return this.cantEdit()
    }

    const that = this
    this.setState(
      {
        plateformClassifyData: [
          {
            displayValue(item: any) {
              return item.cat_name
            },
            list: this.state.plateformClassifyData[0].list,
          },
          {
            displayValue(item: any) {
              return item.cat_name
            },
            list: [],
          },
          {
            displayValue(item: any) {
              return item.cat_name
            },
            list: [],
          },
        ],
      },
      () => {
        // 显示弹框
        ;(PickerBox as any).open({
          data: that.state.plateformClassifyData,
          valueLable: "cat_id",
          labelName: "cat_name",
          onChange: (data: any, index: number, arr: any) => {
            const result = arr
            if (data && data.level === 0) {
              this.state.plateformClassifyData[1].list = data.children
              // 重写结果数据
              result[1] = data.children[0]
              ;(PickerBox as any).changeState(result)
              this.state.plateformClassifyData[2].list = ((data: any) => {
                if (
                  data &&
                  data.length > 0 &&
                  data[0].children &&
                  data[0].children.length > 0
                ) {
                  result[2] = data[0].children[0]
                  ;(PickerBox as any).changeState(result)
                  return data[0].children
                } else {
                  result[2] = []
                  return []
                }
              })(data.children)
              this.setState({
                plateformClassifyData: this.state.plateformClassifyData,
              })
            } else if (data && data.level === 1) {
              this.state.plateformClassifyData[2].list = data.children
              result[2] = data.children[0]
              ;(PickerBox as any).changeState(result)
              this.setState({
                plateformClassifyData: this.state.plateformClassifyData,
              })
            }
          },
          // 成功回调
          onConfrim: (data: any) => {
            this.setState({
              plateformName: data.nameArr,
              platform_cate_fir: data.valueArr[0] || 0,
              platform_cate_sec: data.valueArr[1] || 0,
              platform_cate_thr: data.valueArr[2] || 0,
            })
          },
        })
      }
    )
  }

  // 显示物性特征
  private showAttributeBox() {
    if (this.state.is_cmall_goods === "1") {
      return this.cantEdit()
    }

    this.setState({
      attributeSort: "",
      attributeName: "",
      attributeNumerical: "",
      attributeUnit: "",
      attributeRemark: "",
      showAttribute: true,
    })
  }

  // 添加物性特征
  private changeAttribute() {
    const isRepeat = this.state.phyical.some((v: any, k: number) => {
      const sortNum = Number(v.sort)
      const sortAttribute = Number(this.state.attributeSort)
      if (this.state.attributeAperation === "edit") {
        return sortNum === sortAttribute && k !== this.state.editIndex
      } else {
        return sortNum === sortAttribute
      }
    })

    if (!this.state.attributeSort.toString().replace(/\s*/g, "")) {
      alert.open({
        promptText: "排序不能为空！",
      })
      return
    } else if (isRepeat) {
      alert.open({
        promptText: "排序不能重复！",
      })
      return
    }
    if (!this.state.attributeName.replace(/\s*/g, "")) {
      alert.open({
        promptText: "物性名称不能为空！",
      })
      return
    }

    const data = {
      sort: this.state.attributeSort,
      name: this.state.attributeName,
      numerical: this.state.attributeNumerical,
      unit: this.state.attributeUnit,
      remark: this.state.attributeRemark,
    }

    if (this.state.attributeAperation !== "edit") {
      // sort name numerical unit remark
      this.setState({
        phyical: [...this.state.phyical, data],
        showAttribute: false,
      })
    } else {
      this.state.phyical[this.state.editIndex] = data
      this.setState({
        phyical: this.state.phyical,
        showAttribute: false,
      })
    }
  }

  // 修改物性特征
  private editAttribute(v: any, index: number) {
    this.setState({
      attributeSort: v.sort,
      attributeName: v.name,
      attributeNumerical: v.numerical,
      attributeUnit: v.unit,
      attributeRemark: v.remark,
      showAttribute: true,
      attributeAperation: "edit",
      editIndex: index,
    })
  }

  // 删除物性特征
  private removeAttribute() {
    this.state.phyical.splice(this.state.editIndex, 1)
    this.setState({
      editIndex: -1,
      showAttribute: "",
      attributeAperation: "",
    })
  }

  // 显示计量单位
  private showUnitContainer() {
    if (this.state.is_cmall_goods === "1") {
      return this.cantEdit()
    }

    this.setState({
      showUnit: true,
      radioUnitIndex: this.state.unit_type,
      unit_customize:
        this.state.radioUnitIndex === 3 ? this.state.unit_customize : "",
    })
  }

  // 计量单位确认
  private onConfirmUnit() {
    if (this.state.radioUnitIndex === 3) {
      if (!this.state.unit_customize.replace(/\s*/g, "")) {
        alert.open({
          promptText: "自定义单位不能为空！",
        })
        return
      }
    }

    this.setState({
      showUnit: false,
      unit_type: this.state.radioUnitIndex,
    })
  }

  // 显示梯度
  private showGradient() {
    this.setState({
      showHierarchicalPrice: true,
      price_data: this.state.price,
    })
  }

  // 添加梯度
  private addGradient() {
    if (this.state.price_data.length > 2) {
      return alert.open({
        promptText: "最多只能添加3个梯度价格",
      })
    }
    this.setState({
      price_data: [
        ...this.state.price_data,
        {
          begin_num: "",
          end_num: "",
          origin_price: "",
          discount_price: "",
          price_level: "",
        },
      ],
    })
  }
  // 梯度数据改变
  private changeGradientInputVal(name: string, v: any, k: number) {
    this.state.price_data[k][name] = v

    this.setState({
      price_data: this.state.price_data,
    })
  }
  // 梯度 确认函数
  private onConfrimGradient() {
    const pdata = this.state.price_data
    pdata.forEach((v: any, k: number) => {
      v.price_level = k + 1
    })
    this.setPriceText(pdata)
    this.setState({
      price: pdata,
      showHierarchicalPrice: false,
    })
  }

  /**
   * 设置梯度价显示
   * @param data {any} 数据
   */
  private setPriceText(data: any) {
    let priceText = ""
    if (data.length === 1) {
      priceText = data[0].discount_price || data[0].origin_price
    } else {
      const tempPrice: any[] = ["", ""]
      data.map((v: any, k: number) => {
        if (tempPrice[0] === "") {
          tempPrice[0] = v.discount_price || v.origin_price
        }
        tempPrice[1] = v.discount_price || v.origin_price
      })
      priceText = tempPrice.reverse().join("-")
    }
    this.setState({
      priceText,
    })
  }

  // 添加图片
  private imgSuccess(v: any) {
    if (this.state.goods_img.length >= 5) {
      alert.open({
        promptText: "商品图片最大上传数量为5！",
      })
      return
    }

    if (v) {
      this.setState({
        goods_img: [...this.state.goods_img, v],
      })
    }
  }

  // 修改图片
  private changeImageUrl(v: any, k: number) {
    this.state.goods_img[k] = v

    this.setState({
      goods_img: this.state.goods_img,
    })
  }

  // 显示富文本
  private showEditorContainer() {
    if (this.state.is_cmall_goods === "1") {
      return this.cantEdit()
    }

    this.setState({
      showEditor: true,
      goodsInfoText: this.state.goods_desc,
    })
  }
  // 富文本改变
  private changeEditor(v: any) {
    this.setState({
      goodsInfoText: v,
    })
  }
  // 商品详情富文本确认
  private onConfrimEditor() {
    if (
      /https?:\/\/(?![^\/]*\.?(ibuychem|hzeyun|ylcool)\.com)/gim.test(
        this.state.goodsInfoText
      )
    ) {
      return Toast.T.notify("商品详情不能有链接，请删除链接再发布")
    }
    this.setState({
      goods_desc: this.state.goodsInfoText,
      showEditor: false,
    })
  }

  // 特色商品
  private async getCommodityLabel() {
    const r = await request({
      method: "post",
      url: `${config.MALLAPI}api/shop/goods/tag`,
    })

    if (r.error_code === 0) {
      this.setState({
        checkboxList: r.data,
      })
    }
  }

  /**
   * [submitForm 发布 & 下架]
   * @param  {[number]} type [1 发布 2 下架]
   */
  private async submitForm(type: number) {
    if (!this.state.goods_cate_fir.replace(/\s*/g, "")) {
      alert.open({
        promptText: "商品分类不能为空！",
      })
      return
    }
    if (!this.state.goods_name.replace(/\s*/g, "")) {
      alert.open({
        promptText: "商品名称不能为空！",
      })
      return
    }

    if (!this.state.unit_type.toString().replace(/\s*/g, "")) {
      alert.open({
        promptText: "计量单位不能为空！",
      })
      return
    }
    if (
      this.state.unit_type === 3 &&
      !this.state.unit_customize.replace(/\s*/g, "")
    ) {
      alert.open({
        promptText: "自定义单位不能为空！",
      })
      return
    }
    if (!this.state.point_num.toString().replace(/\s*/g, "")) {
      alert.open({
        promptText: "采购量小数位不能为空！",
      })
      return
    }

    if (
      this.state.price_type === "2" &&
      !this.state.show_origin_price.replace(/\s*/g, "")
    ) {
      alert.open({
        promptText: "原价不能为空！",
      })
      return
    }

    if (
      this.state.price_type === "2" &&
      !this.state.show_discount_price.replace(/\s*/g, "")
    ) {
      alert.open({
        promptText: "优惠价不能为空！",
      })
      return
    }

    if (
      this.state.reference_price !== "" &&
      (this.state.reference_price <= 0 || isNaN(this.state.reference_price))
    ) {
      return alert.open({
        promptText: "参考价必须大于0",
      })
    }

    if (!this.state.stock.toString().replace(/\s*/g, "")) {
      alert.open({
        promptText: "库存不能为空！",
      })
      return
    }

    if (this.state.goods_img.length < 1) {
      alert.open({
        promptText: "商品图片不能为空！",
      })
      return
    }

    if (!this.state.goods_desc.replace(/\s*/g, "")) {
      alert.open({
        promptText: "商品详情不能为空！",
      })
      return
    }

    if (!this.state.platform_cate_fir.replace(/\s*/g, "")) {
      alert.open({
        promptText: "商品分类不能为空！",
      })
      return
    }

    const r = await request({
      method: "post",
      url: `${config.MALLAPI}api/shop/goods/deal`,
      data: {
        companyId: this.state.companyId,
        goods_name: this.state.goods_name,
        grade: this.state.grade,
        manufacturer: this.state.manufacturer,
        phyical: JSON.stringify(this.state.phyical),
        unit_type: this.state.unit_type,
        unit_customize: this.state.unit_customize,
        point_num: this.state.point_num,
        price_type: this.state.price_type,
        price: JSON.stringify(this.state.price),
        show_origin_price: this.state.show_origin_price,
        show_discount_price: this.state.show_discount_price,
        warehouse: this.state.warehouse,
        stock: this.state.stock,
        goods_img: this.state.goods_img.join(),
        platform_cate_fir: this.state.platform_cate_fir,
        platform_cate_sec: this.state.platform_cate_sec,
        platform_cate_thr: this.state.platform_cate_thr,
        type_id: this.state.type_id.join(),
        goods_cate_fir: this.state.goods_cate_fir,
        goods_cate_sec: this.state.goods_cate_sec,
        goods_desc: encodeURIComponent(this.state.goods_desc),
        goods_id: this.state.goods_id,
        proposed_price: this.state.reference_price,
        goods_status: type,
        goods_video: this.state.video,
        video_img: this.state.videoPoster,
        video_img_auto: this.state.videoCutPoster,
      },
    })

    alert.open({
      promptText: r.msg,
    })

    if (r.error_code === 0) {
      // 如果不是编辑
      // if(this.state.operation === 'edit') {
      ;(this.props as any).history.goBack(-1)
      // }
      // (window as any).integral.sign({
      //     env: config.ENV === 'production' ? 'pro' : 'dev',
      //     code: '00_04_00_005',
      //     entityType: 'ws_goods',
      //     system: 3,
      //     callback: function() {
      //     	(that.props as any).history.goBack(-1);
      //     }
      // });
    }
    // else {
    // 	Toast.T.notify(r.msg);
    // }
  }

  // 商品上下架
  private async changeCommodityStatus() {
    const r = await request({
      method: "post",
      url: `${config.MALLAPI}api/shop/goods/operate`,
      data: {
        companyId: this.state.companyId,
        ids: this.state.goods_id,
        type: this.state.goods_status === "1" ? 2 : 1,
      },
    })

    alert.open({
      promptText: r.msg,
    })

    if (r.error_code === 0) {
      ;(this.props as any).history.goBack(-1)
    }
  }
  // 删除
  private async removeCommodity() {
    const r = await request({
      method: "post",
      url: `${config.MALLAPI}api/shop/goods/operate`,
      data: {
        companyId: this.state.companyId,
        ids: this.state.goods_id,
        type: 3,
      },
    })

    alert.open({
      promptText: r.msg,
    })

    if (r.error_code === 0) {
      ;(this.props as any).history.goBack(-1)
    }
  }

  /**
   * 移除添加价格
   * @param index {number} 索引
   */
  private removePrice(index: number) {
    const temp = this.state.price_data
    temp.splice(index, 1)
    this.setState({
      price_data: temp,
    })
  }

  /**
   * 删除上传图片
   * @param index {number} 图片索引
   */
  private removeAction(index: number) {
    const temp = this.state.goods_img
    temp.splice(index, 1)
    this.setState({
      goods_img: temp,
    })
  }

  // 不可编辑
  private cantEdit() {}

  private deleteVideoPoster() {
    this.setState({
      videoPoster: "",
    })
  }

  private uploadVideoPoster(data: any) {
    this.setState({
      videoPoster: data,
    })
  }

  private async uploadVideo(e: any) {
    const file = e.currentTarget.files[0]
    if (!file) {
      return
    }
    e.currentTarget.value = ""
    Toast.T.loading("视频上传中...")
    const suffix = file.type.substring(file.type.indexOf("/") + 1)
    if ("MP4".indexOf(suffix.toUpperCase()) === -1) {
      e.currentTarget.value = ""
      return Toast.T.notify("视频格式错误，仅支持MP4格式")
    }
    if (file.size / 1000 > 100000) {
      e.currentTarget.value = ""
      return Toast.T.notify("视频大小不能超过100M")
    }

    const r = await uploadVideoMultiChunks(file)

    if (r.flag == "1") {
      this.setState({
        video: r.data,
      })
      // 截图视频第一帧
      this.createVideoPoster()
    }
  }
  private createVideoPoster() {
    var canvas: any = document.getElementById("video-canvas") // 获取 canvas 对象
    const ctx = canvas.getContext("2d") // 绘制2d
    var video: any = document.getElementById("video")
    video.crossOrigin = "anonymous" // 解决跨域问题，也就是提示污染资源无法转换视频
    video.currentTime = 1 // 第一帧
    video.oncanplay = () => {
      canvas.width = video.clientWidth // 获取视频宽度
      canvas.height = video.clientHeight // 获取视频高度
      // 利用canvas对象方法绘图
      ctx.drawImage(video, 0, 0, video.clientWidth, video.clientHeight)
      // 转换成base64形式
      const img = canvas.toDataURL("image/png")
      const imgFile = this.base64ToFile(img, "video-poster")
      this.uploadCutVideoPoster(imgFile, "video-poster.png")
    }
  }
  private base64ToFile(data: any, name: string) {
    var arr = data.split(",")
    var mime = arr[0].match(/:(.*?);/)[1]
    var bstr = atob(arr[1])
    var n = bstr.length
    var u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    //转换成file对象
    return new File([u8arr], name, { type: mime })
  }
  private async uploadCutVideoPoster(file: any, name: string) {
    const formdata = new FormData()
    formdata.append("file", file, name)
    try {
      let url = `${config.API}file/uploadMulti`
      formdata.append("rootPath", "wiseshop")
      formdata.append("ratio", "50x0,100x0,200x0,400x0,750x0,1500x0")
      const r = await fetch(url, {
        body: formdata,
        credentials: "include",
        method: "POST",
        mode: "cors",
      }).then((response) => response.json())

      this.setState({
        videoCutPoster: r["750x0"],
      })
      Toast.T.loaded()
    } catch (error) {}
  }

  // 删除视频
  private deleteVideo() {
    this.setState({
      video: "",
      videoCutPoster: "",
    })
  }
}
